<!--
  --
  -- 個人情報設定 ページ
  --
  -->
<template>
  <c-container form>
    <c-profile-group
      :profile="profile"
      @submit="onSubmit"
    >
      <!-- タイトル -->
      <template #title>会員情報を設定</template>

      <!-- 説明文 -->
      <template>
        <p>
          会員情報を入力して下さい。
        </p>
      </template>

      <template #submit-text>次へ</template>
    </c-profile-group>

    <!-- タイムアウト制御 -->
    <c-timeout/>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CProfileGroup from './CProfileGroup'
import CTimeout from '../CTimeout'

import { run } from '@/libs/a'

export default {
  name: 'Profile',
  mixins: [
    page('会員情報を設定')
  ],
  components: {
    CProfileGroup,
    CTimeout
  },
  computed: {
    profile () {
      return this.getters['register/profile']
    }
  },
  methods: {
    /**
     * フォームが入力された
     *
     * @param {Object} form 入力されたフォーム内容
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onSubmit (form, failed) {
      run(async () => {
        // store に個人情報を保存する
        this.commit('register/setProfile', form)

        // 次のページへ
        await this.goTo({ name: 'register/license' })
      })
    }
  }
}
</script>
